var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"yeti-counter",class:{ 'has-background-primary': _vm.isPrimary }},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }